var d = Object.defineProperty;
var p = (i, r, t) => r in i ? d(i, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[r] = t;
var a = (i, r, t) => p(i, typeof r != "symbol" ? r + "" : r, t);
import { a as u, M as w } from "../../CustomPopupNavigator-Bz9uYcKp.js";
import { C as c } from "../../index-D7cgykJH.js";
import { B as f } from "../../index-BZpqZYNM.js";
class k {
  constructor(r, t, e, o = "daymap-companion") {
    a(this, "client_id");
    a(this, "acr_values");
    a(this, "redirect_uri");
    a(this, "authority");
    a(this, "response_type");
    a(this, "scope");
    a(this, "silent_redirect_uri");
    if (this.client_id = r, this.authority = t, this.response_type = "code", this.scope = "openid offline_access", c.isNativePlatform())
      this.redirect_uri = `${o}://${e}/auth`, this.silent_redirect_uri = `${o}://${e}/authsilent`, this.acr_values = `${o}://${e}/auth`;
    else {
      let s = r === "Connect.API" ? "portal" : "portals/student";
      r === "Daymap.API" && window.location.pathname.toLowerCase().startsWith("/lms/app") && (s = "lms/app"), this.redirect_uri = `${window.location.origin}/${s}/auth`, this.silent_redirect_uri = `${window.location.origin}/${s}/authsilent`, this.acr_values = `${window.location.origin}/${s}/auth`;
    }
  }
}
class M {
  constructor(r, t, e, o) {
    a(this, "UserManager");
    a(this, "isLocked", !1);
    a(this, "onSignInError");
    a(this, "schoolCode");
    this.UserManager = new u(
      r,
      void 0,
      c.isNativePlatform() ? new w() : void 0
    ), this.onSignInError = e, t && (t.toStorageString = () => JSON.stringify(t), this.UserManager.storeUser(t), this.schoolCode = o);
  }
  async GetAccessToken(r) {
    for (; this.isLocked; )
      await new Promise((t) => setTimeout(t, 50));
    this.isLocked = !0;
    try {
      let t = await this.UserManager.getUser();
      if (!t || t.expired) {
        if (r || !t)
          if (c.isNativePlatform())
            try {
              await this.UserManager.signinPopup({ state: window.location.href, prompt: "login" }), f.close();
            } catch (e) {
              console.log("Error returned by signInPopup", e);
            }
          else
            await this.UserManager.signinRedirect({ state: window.location.href, prompt: "login" });
        else
          await this.UserManager.signinSilent();
        t = await this.UserManager.getUser();
      }
      return t ? t.access_token : "no token";
    } catch {
      return this.onSignInError && this.onSignInError(), this.GetAccessToken(!0);
    } finally {
      this.isLocked = !1;
    }
  }
  async SignOut() {
    try {
      await this.UserManager.signoutSilent();
    } catch (r) {
      console.error(r);
    }
  }
  async GetResponse({ url: r, data: t, config: e }) {
    const o = await this.GetAccessToken(!1);
    if (!o)
      throw Error("No valid access token could be found");
    e || (e = { headers: { "Content-Type": "application/json" } }), e.headers || (e.headers = { "Content-Type": "application/json" }), t != null && t !== void 0 ? (e.method || (e.method = "POST"), e.dontStringify ? e.body = t : e.body = JSON.stringify(t)) : e.method || (e.method = "GET"), e.credentials = "omit", e.headers.Authorization = "Bearer " + o;
    const s = await fetch(r, e);
    if (!s.ok) {
      const h = await s.text();
      try {
        throw JSON.parse(h);
      } catch {
        throw {
          title: "Error",
          status: s.status,
          detail: h || s.statusText || "An error occurred"
        };
      }
    }
    if (s.status === 204)
      return null;
    if (e.asResponse)
      return s;
    if (e.asBlob)
      return await s.blob();
    if (e.asText)
      return await s.text();
    let n = await s.json();
    return n = l(n), await n;
  }
}
const y = (i) => typeof i == "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(i), l = (i) => i === null || typeof i != "object" ? i : Array.isArray(i) ? i.map(l) : Object.fromEntries(
  Object.entries(i).map(([r, t]) => [
    r,
    y(t) ? new Date(t) : l(t)
  ])
);
export {
  M as DaymapOidc,
  k as DaymapOidcConfig
};
//# sourceMappingURL=daymapoidc.js.map
